let accessLink = document.querySelector(".js-accessLink");
let footerAccessLink = document.querySelector(".js-footer-accessLink");
let footerSpAccessLink = document.querySelector(".js-footer-sp-accessLink");
let spAccess = document.getElementById("spAccess");
const accessSection = document.getElementById("ACCESS");

// accessLinkをクリックしたときにスクロール関数を呼び出す
accessLink.addEventListener("click", (e) => {
  e.preventDefault(); // リンクのデフォルトの動作を無効にする
  const rect = accessSection.getBoundingClientRect();
  const offset = window.scrollY + rect.bottom - 140; // 現在のスクロール位置と上端の位置を合算
  if (accessSection) {
    window.scrollTo({
      top: offset,
      behavior: "smooth",
    });
  }
  if (120 > rect.bottom) {
    window.scrollTo({
      top: 3355,
      behavior: "smooth",
    });
  }
  if (window.innerWidth < 767) {
    console.log("スマホの時");
    if (120 > rect.bottom) {
      window.scrollTo({
        top: offset,
        behavior: "smooth",
      });
    }
  }
});

// accessLinkをクリックしたときにスクロール関数を呼び出す
footerAccessLink.addEventListener("click", (e) => {
  e.preventDefault(); // リンクのデフォルトの動作を無効にする
  const rect = accessSection.getBoundingClientRect();
  if (120 > rect.bottom) {
    window.scrollTo({
      top: 3355,
      behavior: "smooth",
    });
  }
});

// accessLinkをクリックしたときにスクロール関数を呼び出す
footerSpAccessLink.addEventListener("click", (e) => {
  e.preventDefault(); // リンクのデフォルトの動作を無効にする
  const rect = accessSection.getBoundingClientRect();
  const offset = window.scrollY + rect.bottom - 140; // 現在のスクロール位置と上端の位置を合算

  if (120 > rect.bottom) {
    window.scrollTo({
      top: offset,
      behavior: "smooth",
    });
  }
});
